import _ from "lodash";

export const formulariNoShanModificatDades = (
  dadesOriginals,
  dadesEditades
) => {
  return _.isEqual(dadesOriginals, dadesEditades);
};

export const hiHaErrorsCampsFormulari = errorsCamps =>
  Object.keys(errorsCamps).some(idCamp => errorsCamps[idCamp] !== false);

const obtenirMissatgeErrorCampObligatori = valor => {
  const missatgeCampObligatori = "Camp obligatori";
  return valor ? false : missatgeCampObligatori;
};

const obtenirMissatgeErrorCampLlistaObligatori = valor => {
  const missatgeCampObligatori = "Camp obligatori";
  return valor && Array.isArray(valor) && valor.length > 0
    ? false
    : missatgeCampObligatori;
};

const obtenirMissatgeErrorCampNombreCaractersIncorrecte = (
  valor,
  nombreCaracters
) => {
  const missatgeCampNoTeNombreCaractersCorrecte = `El camp ha de tenir ${nombreCaracters} caràcters`;
  return valor && valor.length !== nombreCaracters
    ? missatgeCampNoTeNombreCaractersCorrecte
    : false;
};

const obtenirMissatgeErrorDataAltaPosteriorDataBaixa = (
  dataAltaText,
  dataBaixaText
) => {
  const missatgeDataAltaPosteriorDataBaixa =
    "La data d'alta no pot ser posterior a la data de baixa";
  return dataAltaText > dataBaixaText
    ? missatgeDataAltaPosteriorDataBaixa
    : false;
};

const obtenirMissatgeErrorCampDataAlta = (
  //dataActualText,
  dataAlta,
  dataBaixa
) => {
  return (
    obtenirMissatgeErrorCampObligatori(dataAlta) ||
    obtenirMissatgeErrorDataAltaPosteriorDataBaixa(dataAlta, dataBaixa)
  );
};

const validarFormatCorreuElectronic = email => {
  const missatgeCorreuElectronicFormatIncorrecte =
    "El correu electrònic ha de tenir un format vàlid";
  const expressioRegularEmail = /[^@]+@[^@]+\.[^@]+/;
  return email && !email.match(expressioRegularEmail)
    ? missatgeCorreuElectronicFormatIncorrecte
    : false;
};

const validarFormatNumeric = valor => {
  const missatgeValorFormatIncorrecte = "Camp numèric";
  return valor && isNaN(valor) ? missatgeValorFormatIncorrecte : false;
};

export const obtenirErrorsDadesObservador = (
  dadesEditades,
  esNouObservador
) => {
  const {
    nom,
    cognom1,
    cognom2,
    carrer,
    codiINE,
    codiPostal,
    telefon,
    usuariNom,
    usuariCorreuElectronic,
    usuariRol,
    dataAlta,
    dataBaixa
  } = dadesEditades;

  return {
    nom: obtenirMissatgeErrorCampObligatori(nom),
    cognom1: obtenirMissatgeErrorCampObligatori(cognom1),
    cognom2: obtenirMissatgeErrorCampObligatori(cognom2),
    carrer: obtenirMissatgeErrorCampObligatori(carrer),
    codiINE: obtenirMissatgeErrorCampObligatori(codiINE),
    codiPostal:
      obtenirMissatgeErrorCampObligatori(codiPostal) ||
      validarFormatNumeric(codiPostal) ||
      obtenirMissatgeErrorCampNombreCaractersIncorrecte(codiPostal, 5),
    telefon:
      obtenirMissatgeErrorCampObligatori(telefon) ||
      validarFormatNumeric(telefon) ||
      obtenirMissatgeErrorCampNombreCaractersIncorrecte(telefon, 9),
    usuariNom: obtenirMissatgeErrorCampObligatori(usuariNom),
    usuariCorreuElectronic:
      obtenirMissatgeErrorCampObligatori(usuariCorreuElectronic) ||
      validarFormatCorreuElectronic(usuariCorreuElectronic),
    usuariRol: obtenirMissatgeErrorCampObligatori(usuariRol),
    dataAlta: esNouObservador
      ? obtenirMissatgeErrorCampDataAlta(dataAlta, dataBaixa)
      : false
  };
};

export const obtenirErrorsDadesIndret = dadesEditades => {
  const {
    clima,
    descripcio,
    distanciaMar,
    nomObservador,
    nom,
    orientacio,
    paisatge,
    relleu
  } = dadesEditades;

  return {
    nom: obtenirMissatgeErrorCampObligatori(nom),
    nomObservador: obtenirMissatgeErrorCampObligatori(nomObservador),
    clima: obtenirMissatgeErrorCampObligatori(clima),
    descripcio: obtenirMissatgeErrorCampObligatori(descripcio),
    distanciaMar:
      obtenirMissatgeErrorCampObligatori(distanciaMar) ||
      validarFormatNumeric(distanciaMar),
    orientacio: obtenirMissatgeErrorCampObligatori(orientacio),
    paisatge: obtenirMissatgeErrorCampObligatori(paisatge),
    relleu: obtenirMissatgeErrorCampObligatori(relleu)
  };
};

export const hiHaErrorsDadesFormulari = errors => {
  return Object.values(errors).filter(error => {
    return error !== false;
  });
};

export const fotosOriginalsMenysFotosEliminades = (originals, eliminades) => {
  return _.differenceWith(originals, eliminades, _.isEqual);
};

export const obtenirErrorsDadesIndividu = dadesEditades => {
  const {
    idIndret,
    idObservador,
    latitud,
    longitud,
    altitud,
    descripcio,
    nomEspecie,
    indretIndividuDataAlta,
    fenofases
  } = dadesEditades;

  return {
    nom: obtenirMissatgeErrorCampObligatori(idIndret),
    nomObservador: obtenirMissatgeErrorCampObligatori(idObservador),
    latitud:
      obtenirMissatgeErrorCampObligatori(latitud) ||
      validarFormatNumeric(latitud),
    longitud:
      obtenirMissatgeErrorCampObligatori(longitud) ||
      validarFormatNumeric(longitud),
    altitud:
      obtenirMissatgeErrorCampObligatori(altitud) ||
      validarFormatNumeric(altitud),
    nomEspecie: obtenirMissatgeErrorCampObligatori(nomEspecie),
    descripcio: obtenirMissatgeErrorCampObligatori(descripcio),
    indretIndividuDataAlta: obtenirMissatgeErrorCampObligatori(
      indretIndividuDataAlta
    ),
    fenofases: obtenirMissatgeErrorCampLlistaObligatori(fenofases)
  };
};

export const esLlistaBuida = (dades, camp) => {
  if (!dades) {
    return true;
  }
  const dadesCamp = camp ? dades[camp] : dades;
  if (!dadesCamp || !Array.isArray(dadesCamp)) {
    return true;
  }

  if (dadesCamp.length === 0) {
    return true;
  }
  return false;
};
